import { render } from "./ColoursView.vue?vue&type=template&id=705b2c00"
import script from "./ColoursView.vue?vue&type=script&lang=js"
export * from "./ColoursView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__